import { CardActions } from 'bricks-ui/packages/bricks-ui';

export default CardActions;
